import {
    backend_url,
    tinymce_init,
    commaNumber,
} from "./../../../environments/environment";
import { AuthService } from "./../../services/auth.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import swal from "sweetalert2";

@Component({
    selector: "app-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
    @ViewChild("modalaccion") modal: NgbModal;

    modalReference: any;

    completas = 0;
    tinymce_init = tinymce_init;
    commaNumber = commaNumber;

    tarea = {
        tarea: "",
        fecha: "",
        asignado: "",
        completa: 0,
    };

    accion = {
        id: 0,
        tipo: "",
        tarea: 0,
        seguimiento: "",
        programar: 0,
        fecha: "",
        adjuntos: [],
    };

    usuarios: any[] = [];
    tareas: any[] = [];

    documentos = {
        compra: {
            documentos: 0,
            total: 0,
        },
        pedido: {
            documentos: 0,
            total: 0,
        },
        factura: {
            documentos: 0,
            total: 0,
        },
    };

    constructor(
        private http: HttpClient,
        private auth: AuthService,
        private modalService: NgbModal
    ) {}

    ngOnInit() {
        this.http.get(`${backend_url}dashboard/todo/data`).subscribe(
            (res) => {
                this.tareas = res["tareas"];
                this.usuarios = res["usuarios"];
                this.documentos = res["documentos"];
            },
            (response) => {
                swal({
                    title: "",
                    type: "error",
                    html:
                        response.status == 0
                            ? response.message
                            : typeof response.error === "object"
                            ? response.error.error_summary
                            : response.error,
                });
            }
        );
    }

    crearTarea() {
        if (this.tarea.tarea == "") {
            swal({
                type: "error",
                html: "Escribe una tarea para poder registrarla.",
            });

            return;
        }

        const form_data = new FormData();
        form_data.append("data", JSON.stringify(this.tarea));

        this.http
            .post(`${backend_url}dashboard/todo/crear`, form_data)
            .subscribe(
                (res) => {
                    swal({
                        title: "",
                        type: res["code"] == 200 ? "success" : "error",
                        html: res["message"],
                    });

                    if (res["code"] == 200) {
                        this.tareas = res["tareas"];

                        this.tarea = {
                            tarea: "",
                            fecha: "",
                            asignado: "",
                            completa: 0,
                        };
                    }
                },
                (response) => {
                    swal({
                        title: "",
                        type: "error",
                        html:
                            response.status == 0
                                ? response.message
                                : typeof response.error === "object"
                                ? response.error.error_summary
                                : response.error,
                    });
                }
            );
    }

    terminarTarea(tarea_id) {
        const tarea = this.tareas.find((tarea) => tarea.id == tarea_id);
        const user = JSON.parse(this.auth.userData().sub);

        if (tarea.id_asignado != user.id) {
            swal({
                type: "error",
                html: "No puedes terminar esta tarea ya que no se te fue asignada.",
            });

            return;
        }

        if (
            tarea.accion != 0 &&
            tarea.status &&
            !tarea.transformada &&
            this.accion.id == 0
        ) {
            this.accion = {
                id: tarea.accion.id_accion,
                tipo: tarea.accion.tipo,
                tarea: tarea_id,
                seguimiento: "",
                programar: 0,
                fecha: "",
                adjuntos: [],
            };

            this.modalReference = this.modalService.open(this.modal, {
                size: "lg",
                backdrop: "static",
                windowClass: "bigger-modal",
                keyboard: false,
            });

            return;
        }

        if (
            tarea.accion != 0 &&
            tarea.status &&
            !tarea.transformada &&
            this.accion.seguimiento == ""
        ) {
            swal({
                type: "error",
                html: "Debes escribir un seguimiento para poder registrar la acción.",
            });

            return;
        }

        if (
            tarea.accion != 0 &&
            tarea.status &&
            !tarea.transformada &&
            this.accion.programar &&
            this.accion.fecha == ""
        ) {
            swal({
                type: "error",
                html: "Debes especificar una fecha para programar la acción.",
            });

            return;
        }

        const form_data = new FormData();
        form_data.append("tarea_id", tarea_id);
        form_data.append("status", tarea.status);
        form_data.append("accion", JSON.stringify(this.accion));

        this.http
            .post(`${backend_url}dashboard/todo/terminar`, form_data)
            .subscribe(
                (res) => {
                    if (res["code"] == 200) {
                        tarea.status = !tarea.status;

                        if (this.accion.id != 0) {
                            swal({
                                title: "",
                                type: res["code"] == 200 ? "success" : "error",
                                html: res["message"],
                            });

                            this.modalReference.close();
                        }

                        this.accion = {
                            id: 0,
                            tipo: "",
                            tarea: 0,
                            seguimiento: "",
                            programar: 0,
                            fecha: "",
                            adjuntos: [],
                        };
                    }
                },
                (response) => {
                    swal({
                        title: "",
                        type: "error",
                        html:
                            response.status == 0
                                ? response.message
                                : typeof response.error === "object"
                                ? response.error.error_summary
                                : response.error,
                    });
                }
            );
    }

    cargarAdjuntos() {
        this.accion.adjuntos = [];

        const files = $("#archivos").prop("files");
        const archivos = [];

        for (var i = 0, len = files.length; i < len; i++) {
            var file = files[i];

            var reader = new FileReader();

            reader.onload = (function (f) {
                return function (e) {
                    archivos.push({
                        tipo: f.type.split("/")[0],
                        nombre: f.name,
                        data: e.target.result,
                    });
                };
            })(file);

            reader.onerror = (function (f) {
                return function (e) {
                    archivos.push({ tipo: "", nombre: "", data: "" });
                };
            })(file);

            reader.readAsDataURL(file);
        }

        this.accion.adjuntos = archivos;
    }

    cerrarModal() {
        this.tarea = {
            tarea: "",
            fecha: "",
            asignado: "",
            completa: 0,
        };

        this.accion = {
            id: 0,
            tipo: "",
            tarea: 0,
            seguimiento: "",
            programar: 0,
            fecha: "",
            adjuntos: [],
        };

        this.modalReference.close();
    }
}
